import React from 'react';
import { FaPlane, FaKey, FaLaptop, FaWallet, FaPhone } from 'react-icons/fa';
import { Link } from 'react-router-dom';

function ForgottenItemsService() {
  return (
    <div>
      <div
        className="relative bg-cover bg-center h-[400px] md:h-[600px]"
        style={{ backgroundImage: "url('images/forget.png')" }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative z-10 flex flex-col items-center justify-center text-center h-full text-white">
          <h1 className="text-4xl md:text-7xl xl:text-8xl font-semibold tracking-tight">Forgotten Something Important?</h1>
        </div>
      </div>

      <section className="flex items-center justify-center py-16 bg-white text-black">
        <div className="max-w-4xl mx-auto text-center">
          {/* Hero Section */}
          <div className="bg-white p-8 rounded-lg shadow-lg relative z-10 mb-10">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-12 text-6xl text-black">
              <FaPlane />
            </div>
            <p className="text-lg mb-6 font-thin text-black text-justify">
              Whether it's your passport, keys, phone, or any other important item, our fast and reliable delivery service ensures that it gets to you quickly, so you don’t miss your flight or meeting.
            </p>
            <p className="text-lg text-black font-thin">
              We understand the urgency, and we're here to make sure that whatever you’ve forgotten, we’ll bring it to you in no time.
            </p>
          </div>

          {/* How It Works Section */}
          <div className="bg-white p-8 rounded-lg shadow-lg mb-12">
            <h3 className="text-3xl font-thin text-white mb-6">How It Works</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12">
              <div className="flex flex-col items-center text-center">
                <div className="text-6xl text-black mb-4">
                  <FaKey />
                </div>
                <h4 className="text-2xl font-thin mb-2">Request a Pickup</h4>
                <p className="text-black font-thin">Simply let us know what you’ve forgotten, and we'll arrange a quick pickup from your location.</p>
              </div>
              <div className="flex flex-col items-center text-center">
                <div className="text-6xl text-black mb-4 font-thin">
                  <FaPhone />
                </div>
                <h4 className="text-2xl font-thin mb-2">Fast Delivery</h4>
                <p className="text-black font-thin">Once we collect your item, we’ll deliver it to you swiftly, so you don't miss out on anything important.</p>
              </div>
              <div className="flex flex-col items-center text-center">
                <div className="text-6xl text-black mb-4">
                  <FaLaptop />
                </div>
                <h4 className="text-2xl font-thin mb-2">Convenience at Your Fingertips</h4>
                <p className="text-black font-thin">No more stress. We'll handle everything, ensuring that your forgotten item reaches you without delays.</p>
              </div>
            </div>
          </div>

          {/* Forgotten Item Descriptions */}
          <div className="mb-12 text-lg text-black px-3">
            <h3 className="text-3xl font-thin text-white mb-6">Forgotten Item Courier Service</h3>
            <p className='font-thin'>
              Imagine the scene... You're rushing to the airport, passport in hand, when you realize you forgot your phone. Or maybe you get to your hotel room and realize you forgot your keys. Whatever the item may be, we’ve all forgotten something important at one point or another. 
            </p>
            <p className="mt-4 font-thin">
              Forgetting these items can often lead to stressful and expensive situations. We provide a quick and reliable service for people who have forgotten items and need them picked up. So next time you're feeling stressed about a forgotten:
            </p>
            <p className="mt-4 font-thin">
              We have access to over 3000 drivers, which allows us to offer a collection time within 60 minutes from quote approval. Get a free quote today.
            </p>
          </div>

          {/* Specific Situations */}
          <div className="mb-12 text-lg text-black px-1">
            <h3 className="text-3xl font-thin text-white mb-6">I Have Forgotten My Keys or Passport...</h3>
            <div className="mb-6">
              <h4 className="text-2xl font-thin mb-2">Forgot Your Keys?</h4>
              <p className='font-thin'>
                No need to stress, we are able to pick up your forgotten keys. Simply arrange a pickup point, and we promise to pick them up from any location in Mainland UK within 60 minutes and have them delivered to your chosen address on the same day.
              </p>
            </div>
            <div>
              <h4 className="text-2xl font-thin mb-2">At the Airport and Forgot Your Passport?</h4>
              <p className='font-thin'>
                You are at the airport, but you have forgotten your passport. This can be a very stressful situation, as you won’t be able to board your flight without your passport. 1UKLogistics can help! We will pick up your passport and drop it off at any UK mainland terminal, so you can board your flight and enjoy your holiday.
              </p>
            </div>
          </div>

          {/* Call to Action Section */}
          <div className="mt-12 text-center">
            <p className="text-base md:text-lg font-thin text-black mb-6">Forgotten something? Don't worry, we're here to help!</p>
           
            <div className='flex justify-center'>
      <Link to='/contactus'>
    <button  className="px-8 py-4 bg-slate-900 text-white  text-lg font-semibold "> Request a Pickup</button></Link>
    </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ForgottenItemsService;
